/**
 * The gradients a profile can be drawn in, by the name zl-api stores in `profile.gradient`. Only a
 * Habitat Champion wears one (`profile.gradientColor`); the colours come from My Character's swatch.
 */
const PROFILE_GRADIENTS = {
  champion: 'linear-gradient(180deg, #FFCE1F 0%, #CDD565 65.56%)',
} as const;

export type ProfileGradient = keyof typeof PROFILE_GRADIENTS;

export const isProfileGradient = (name: unknown): name is ProfileGradient =>
  typeof name === 'string' && Object.hasOwn(PROFILE_GRADIENTS, name);

/**
 * How a profile's circle is painted: its gradient over its solid colour, or the colour alone when it
 * has no gradient or one this app does not know.
 */
export const profileBackground = (color: string | null | undefined, gradient: string | null | undefined) => ({
  backgroundColor: color ?? undefined,
  backgroundImage: isProfileGradient(gradient) ? PROFILE_GRADIENTS[gradient] : undefined,
});
